import { Fragment, useEffect, useState } from 'react'
import { Dialog, Menu, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon, FunnelIcon } from '@heroicons/react/20/solid'
import Navbar from '../../components/Navbar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LazyLoadImage } from 'react-lazy-load-image-component'


const subCategories = [
    { name: 'All', href: '#', current: true },
    { name: 'Plants', href: '#', current: false },
    { name: 'Seeds', href: '#', current: false },
    { name: 'Planters', href: '#', current: false },
    { name: 'Tools', href: '#', current: false },
    { name: 'Flowering Plants', href: '#', current: false },
]

const Shopping = () => {
    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [sortBy, setSortBy] = useState('')
    const [search, setSearch] = useState('')
    const [category, setCategory] = useState('All')
    const [allProduct, setAllProduct] = useState([])

    const addToCart = (id) => {
        if (localStorage.getItem('token') === null) {
            window.location.href = '/login'
        }
        else {

            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/cart/addtocart', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        productId: id
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        notify(data.message)
                    }
                    ).catch(err => {
                        notify(err.message)
                    })
            } catch (err) {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if (JSON.parse(localStorage.getItem('user')) === 'seller') {
            window.location.href = '/inventory'
        }
        // if (allProduct.length === 0)
        fetch(process.env.REACT_APP_SERVER_URL + '/shop/getAllProduct', {
            method: 'GET', 'Content-Type': 'application/json'
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.success) {
                    // add only active products
                    setProducts(data.allProduct)
                    setAllProduct(data.allProduct)
                    setLoading(false)

                }
            })
            .catch(err => {
                console.log(err)
            })

    }, [])

    useEffect(() => {
        if (category !== 'All' && allProduct.length > 0) {
            // remove products that are not in the category
            // console.log(category)
            let filteredProducts = allProduct.filter(product => product.type === category)
            setProducts(filteredProducts)
            console.log(filteredProducts)
        }
        else {
            setProducts(allProduct)
        }


    }, [category, allProduct])

    useEffect(() => {
        if (sortBy === 'lowToHigh') {
            setProducts(products.sort((a, b) => (a.cost_per_unit < b.cost_per_unit) ? 1 : -1))
        }
        else if (sortBy === 'highToLow') {
            setProducts(products.sort((a, b) => (a.cost_per_unit > b.cost_per_unit) ? 1 : -1))
        }
        else if (sortBy === 'topRated') {
            setProducts(products.sort((a, b) => (a.averageRating < b.averageRating) ? 1 : -1))
        }

        else
            setProducts(products)

    }, [sortBy, products, allProduct])

    useEffect(() => {
        if (search !== '') {
            let filteredProducts = allProduct.filter(product => product.name.toLowerCase().includes(search.toLowerCase()))
            setProducts(filteredProducts)
        }
        else {
            setProducts(allProduct)
        }
    }, [search, allProduct])



    return (
        <div className="bg-[#F8FBF8] dark:bg-black dark:text-white">
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div>
                <Transition.Root show={mobileFiltersOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-40 lg:hidden" onClose={setMobileFiltersOpen}>
                        <Transition.Child
                            as={Fragment}
                            enter="transition-opacity ease-linear duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity ease-linear duration-300"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-40 flex">
                            <Transition.Child
                                as={Fragment}
                                enter="transition ease-in-out duration-300 transform"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transition ease-in-out duration-300 transform"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="relative ml-auto dark:bg-black flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                                    <div className="flex items-center justify-between px-4">
                                        <h2 className="text-lg font-medium dark:text-white text-gray-900">Filters</h2>
                                        <button
                                            type="button"
                                            className="-mr-2 flex h-10 w-10 items-center justify-center dark:bg-black rounded-md bg-white p-2 text-gray-400 dark:text-white"
                                            onClick={() => setMobileFiltersOpen(false)}
                                        >
                                            <span className="sr-only">Close menu</span>
                                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>

                                    {/* Filters */}
                                    <form className="mt-4 border-t border-gray-200">
                                        <h3 className="sr-only">Categories</h3>
                                        <ul className="px-2 py-3 font-medium dark:bg-black dark:text-white text-gray-900">
                                            {subCategories.map((Category) => (

                                                <li key={Category.name}>
                                                    <p className={((category === Category.name) ? 'text-green-600 cursor-pointer hover:text-green-600 block px-2 py-3' : 'block px-2 py-3 cursor-pointer hover:text-green-600')} onClick={() => { setCategory(Category.name); console.log(Category.name) }}>{Category.name}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition.Root>

                <main className="lg:mx-32 px-4 sm:px-6 lg:px-8">
                    <div className="flex items-baseline justify-between border-b border-gray-200 pt-24 pb-6">
                        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight dark:text-white text-gray-900">
                            Product List</h1>
                        {/* search a product */}
                        <div className=" hidden md:flex items-center">
                            <input type="text" placeholder="Search a product" className="dark:bg-black dark:text-white bg-gray-100 border border-gray-300 rounded-md py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" onChange={(e) => { setSearch(e.target.value) }} />
                        </div>
                        <div className="flex items-center">
                            <Menu as="div" className="relative inline-block text-left">
                                <div>
                                    <Menu.Button className="group inline-flex justify-center text-sm font-medium dark:text-white text-gray-700 hover:text-gray-900">
                                        Sort
                                        <ChevronDownIcon
                                            className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 dark:text-white text-gray-400 group-hover:text-gray-500"
                                            aria-hidden="true"
                                        />
                                    </Menu.Button>
                                </div>

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md dark:bg-black dark:text-white  bg-white shadow-2xl ring-1 ring-black dark:ring-white ring-opacity-5 focus:outline-none">
                                        <div className="py-1">
                                            <button className="font-medium text-gray-900 block px-4 py-2 text-sm"

                                                onClick={() => {
                                                    setSortBy('topRated')
                                                    setProducts(products.sort((a, b) => (a.averageRating < b.averageRating) ? 1 : -1))
                                                }}
                                            >
                                                Top Rated
                                            </button>
                                        </div>
                                        <div className="py-1">
                                            <button className="font-medium text-gray-900 block px-4 py-2 text-sm"
                                                onClick={() => {

                                                    setSortBy('lowToHigh');
                                                    setProducts(products.sort((a, b) => (a.cost_per_unit < b.cost_per_unit) ? 1 : -1))
                                                }}
                                            >
                                                Price: High to Low
                                            </button>
                                        </div>
                                        <div className="py-1">
                                            <button className="font-medium text-gray-900 block px-4 py-2 text-sm"

                                                onClick={() => {
                                                    setSortBy('highToLow')
                                                    setProducts(products.sort((a, b) => (a.cost_per_unit > b.cost_per_unit) ? 1 : -1))
                                                }}
                                            >
                                                Price: Low to High
                                            </button>
                                        </div>
                                    </Menu.Items>
                                </Transition>
                            </Menu>


                            <button
                                type="button"
                                className="-m-2 ml-4 p-2 dark:text-white text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
                                onClick={() => setMobileFiltersOpen(true)}
                            >
                                <span className="sr-only">Filters</span>
                                <FunnelIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                    <div className=" flex md:hidden items-center">
                        <input type="text" placeholder="Search a product" className="dark:bg-black dark:text-white bg-gray-100 border border-gray-300 rounded-md py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" onChange={(e) => { setSearch(e.target.value) }} />
                    </div>

                    <section aria-labelledby="products-heading" className="pt-6 pb-24">
                        <h2 id="products-heading" className="sr-only">
                            Products
                        </h2>

                        <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                            <form className="hidden lg:block sticky top-0">
                                <h3 className="sr-only">Categories</h3>
                                <ul className="space-y-4 border-b dark:border-0 border-gray-200 pb-6 text-sm font-medium dark:text-white text-gray-900 dark:bg-black">
                                    {subCategories.map((Category) => (
                                        <li key={Category.name}>
                                            <p className={((category === Category.name) ? 'text-green-600 cursor-pointer hover:text-green-600' : 'cursor-pointer hover:text-green-600')} onClick={() => { setCategory(Category.name); console.log(Category.name) }}>{Category.name}</p>
                                        </li>
                                    ))}
                                </ul>

                            </form>

                            {/* Product grid */}
                            {/*responsive grid*/}
                            <div className="grid grid-cols-1 gap-x-4 gap-y-10 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-3 mx-auto">
                                {
                                    loading ?
                                        <div className="flex justify-center items-center  mx-auto">
                                            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-green-600"></div>
                                        </div> :
                                        products.map((product) => (
                                            <div key={product._id} className="relative border dark:border-slate-700 border-gray-200 rounded-xl shadow-2xl p-2 hover:scale-105 duration-100 delay-100 ease-in-out">
                                                <div className="w-full h-72 border cursor-pointer rounded-lg bg-gray-100  overflow-hidden  hover:opacity-75  xl:h-64">
                                                    <a target="_blank" href={`/dp/${product._id}`} rel="noreferrer" className='h-full w-full '>

                                                        <LazyLoadImage
                                                            alt="ecommerce"
                                                            effect="blur"
                                                            // height={300}
                                                            className="h-full w-full object-cover"
                                                            src={product.imgUrl} // use normal <img> attributes as props
                                                        />
                                                    </a>
                                                </div>
                                                <div className='flex mt-4 flex-row justify-between items-center'>
                                                    <h3 className=" w-48  text-sm dark:text-white text-gray-700 truncate">
                                                        {product.name}
                                                    </h3>
                                                    <div class=" flex flex-row">
                                                        <svg aria-hidden="true" class="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Rating star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                                        <p class="ml-2 text-sm font-bold text-gray-900 dark:text-white">
                                                            {
                                                                product.averageRating

                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <p aria-hidden="true" className="mt-1 text-lg font-medium dark:text-white text-gray-900">
                                                    ₹ {product.cost_per_unit}
                                                </p>
                                                <p className="sr-only">{product.cost_per_unit}</p>
                                                <div className="mt-4">
                                                    {/* view product and add to cart button */}
                                                    <div className="flex gap-2 md:gap-5 w-full lg:gap-1 md:justify-center lg:justify-between">
                                                        <a
                                                            target="_blank" href={`/dp/${product._id}`} rel="noreferrer"
                                                            className="items-center py-2 w-1/2 text-base lg:text-sm md:px-8 md:py-2 rounded-md lg:px-1 lg:py-1.5 text-center font-medium text-white  bg-yellow-500 hover:bg-yellow-600"
                                                        >
                                                            View
                                                        </a>
                                                        {product.quantity > 0 ? <button

                                                            type="button"
                                                            className=" items-center w-1/2 py-2 text-base lg:text-sm md:px-4 md:py-2 rounded-md lg:px-1 lg:py-1.5 text-center font-medium text-white  bg-green-500 hover:bg-green-600"
                                                            onClick={() => { addToCart(product._id); }}
                                                        >
                                                            Add to cart
                                                        </button>
                                                            :
                                                            <button

                                                                type="button"
                                                                className=" items-center w-1/2 py-2 text-base lg:text-sm md:px-4 md:py-2 rounded-md lg:px-1 lg:py-1.5 text-center font-medium text-white  bg-red-500 hover:bg-red-600"
                                                                onClick={() => { notify('Product is out of stock') }}
                                                            >
                                                                Out of Stock
                                                            </button>

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                }
                            </div>

                        </div>
                    </section>
                </main>
            </div>
        </div>
    )
}

export default Shopping